"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ScaleLegend_meta_1 = require("../ScaleLegend.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('div', ScaleLegend_meta_1.SCALE_LEGEND_CATEGORY_KEY, ScaleLegend_meta_1.SCALE_LEGEND_COMPONENT_KEY, ['wrapper']);